/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};


// Sticky header function
timber.stickyHeader = function(){
	$(document).ready(function(){
      
      if(jQuery(window).width() < 768){
        $(".site-header").sticky({topSpacing:0, jitter:0});
      }else{
        if(location.hash!='#minimal') $(".nav-bar").sticky({topSpacing:0, jitter:0});
      }
      
      
      
      
	});
}

timber.mobileBackToTop = function(){
	$(document).ready(function(){
      
      if($(window).width() > 768) return; // Not mobile
		
      $('.up-arrow').show().click(
        function(){
          $("html, body").animate({ scrollTop: 0 });
          return false;
        }
      );
      
	});
}

timber.mobileNav = function(){
      
      var ww = $(window).width();
      
      if(ww > 768) return; // Not mobile
  
  		ww+=100;
  	
      
      $('.mobile-nav > li.has-subm > span').click(
        function(){
          $('.mobile-nav').addClass('on');
          var $li = $(this).closest('li');
          
          $('.mobile-nav .li-on').removeClass('li-on');
          $li.addClass('li-on');
          $('.mobile-nav > li:not(.li-on)').addClass('li-off').hide();
          
          $li.find('ul').show().animate({'right':0});
          $('.mobile-nav').animate({'marginLeft':-ww}, function(){ $('#NavDrawer').animate({'scrollTop':0}); });
          
//           $('.mobile-nav li > span').animate({'opacity':0}, function(){$('.mobile-nav li > span').hide()});
          
//           $('.mobile-nav li .timber-icon-arrow-down').fadeOut();
          $li.find('.back span').text($li.find('span').first().text());
          return false;
        }
      );
      
      
      $('.mobile-nav > li a.back').click(
        function(){
          $('.mobile-nav > li.li-off').removeClass('li-off').show();
          $('.mobile-nav').removeClass('on');
          $('.mobile-nav li > span').show()
//           $('.mobile-nav li > span').animate({'opacity':1}, function(){});
          $(this).closest('ul').animate({'right':-ww});
//           $('.mobile-nav li .timber-icon-arrow-down').fadeIn();
          var $ul = $(this).closest('ul');
          $('.mobile-nav').animate({'marginLeft':0}, function(){ $ul.hide(); });
          return false;
        }
      );
      
      
      $('.mobile-nav li').each(
        function(){
        	var $li = $(this);
          
          	
          	var $ul = $li.find('ul');
          	$ul.css('right', -ww);
          
          	
          
        }
      );
      
      
  $('.mobile-nav-inline li.has-submenu a').click(
        function(){
          timber.resetMobileNav();
          $('.toggle-mobile-nav').click();
	      $('.mobile-nav > li > span:contains('+$(this).text()+')').click();
        }
      );
      
		
      
      
      
}



timber.resetMobileNav = function(){
  
  var ww = $(window).width();
  
  $('.mobile-nav li > span').show()
  $('.mobile-nav li > span').css({'opacity':1});
  $('.mobile-nav > li > ul').css({'right':-ww});
  $('.mobile-nav').css({'marginLeft':0});
  $('.mobile-nav').removeClass('on');
  
}


timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),
    
    // Garments Page
    $garmentsThumbImages     : $('.garment-product-thumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  
//   FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.garmentsProductImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  timber.animateTopSearch();
//   timber.watchScroll();timber

  
  if($(window).width() > 768){
    
	resizeNav();
  	cropNav2();
  }
  
  
  
  jQuery(window).resize( function(e){
    
    if($(window).width() < 768) return;
    
    var a = $('#top-search').outerWidth(true);
    var b = $('.site-header__logo').outerWidth(true);
    var c = $('.site-header__cart-toggle').outerWidth(true);
    
    
    var ow = $(window).data("old_width");
    var nw = $(window).width();
    
//     console.log(a);
//     console.log(b);
//     console.log(c);
    
    var z = nw - (a+b+c+10);
    
//     $('.site-nav').width(z);
    
    
    resizeNav();
    
    if(ow && ow > nw){ // shrink
      cropNav2(nw);
    }else{
      restoreNav2();
    }
    
    
    
    
    
    $(window).data("old_width", $(window).width());
  
  
  } );
  
  // Custom
//   timber.stickyHeader();
  
  refreshLazy();
  
  
  
  presetLazyload();
  timber.mobileBackToTop();
  timber.mobileNav();
  $('.site-nav a, .mobile-nav a').click(function(){ if($(this).attr('href').indexOf('/#/')<0) return; location.href = $(this).attr('href'); location.reload(); });
  
  
  $('#top-search-mobile .timber-icon-x').click(
    function(){
      $('#top-search-mobile').hide();
      $('.toggle-mobile-nav').show();
    }
  );
  
  $('.mobile-top-right-buttons .timber-icon-search').click(
    function(){
      	$('.toggle-mobile-nav').hide();
    	$('#top-search-mobile').show();
      	$('#top-search-mobile input').focus();
    }
  );
  
  
  var $hamburger = $(".hamburger");
  $hamburger.on("click", function(e) {
    
    if($hamburger.hasClass("is-active")){
      $('#NavDrawer').hide();
      $('#PageContainer').show();
    }else{
      timber.resetMobileNav();
      $('#NavDrawer').show();
      $('#PageContainer').hide();
      $('#NavDrawer').scrollTop(0);
    }
    
    $hamburger.toggleClass("is-active");
    // Do something else, like open/close menu
  });
  
  
  // Cookie Mailchimp form email
  $("#mc-embedded-subscribe-form").on('submit', function(){
		setCookie("bluecore_newsletter_email",$("#mail").val(),30);
	});
  
  
  
	// Detect BACK event
	window.onpopstate =  function(event) {
      
      
    	if(event.state && location.href.indexOf('/collections/')) location.reload();
	}
  
  
  
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': ajaxCart.load
  });
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
    
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
      jQuery('#notify-me-block').hide();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
      jQuery('#notify-me-block').show();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Compare at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    jQuery('#notify-me-block').show();
    $quantityElements.hide();
  }
};



timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      var imageId = $(this).attr('data-image-id');
      var selector = '#ProductPhoto-'+imageId;
      
      var thumb_color = variant_images_to_colors[imageId];
      
      $('#productSelect-option-1').val('');
      $('#productSelect-option-1').val(thumb_color);
      $('#ProductPhotoImg').attr('src', newImage);
      
		$('#productSelect-option-1').change();
      
    });
  }
};



timber.garmentsProductImageSwitch = function () {
  if (timber.cache.$garmentsThumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$garmentsThumbImages.on('click', function(evt) {
      
      evt.preventDefault();
      var newImage = $(this).attr('href');
      var imageId = $(this).attr('data-image-id');
      var selector = '#ProductPhoto-'+imageId;

      
      
      jQuery('.garment-product-photos').find('a').hide();
      jQuery(selector).show();
      
//       timber.switchImage(newImage, null, timber.cache.$productImage);

//       $('#ProductPhoto').find('.MagicZoom').attr('href', $(this).attr('href'));
//       $('#ProductPhotoImg').attr('src', newImage);
      
//       MagicZoom.refresh();
      
    });
  }
};




timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
  

  

//   if(jQuery('.MagicZoom').size() > 0){
//     jQuery('.MagicZoom').attr('href', src);
//     console.log(MagicZoom);
//     MagicZoom.refresh();
//   }

  
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};


timber.animateTopSearch = function(){
	$('.search-bar').find('input[name=q]').focus(
      function(){
      	$('.search-bar').addClass('search-focused');
      }
   	);
	
  	$('.search-bar').find('input[name=q]').blur(
      function(){
      	$('.search-bar').removeClass('search-focused');
      }
   	);
}

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

$('.site-nav > li').show();




timber.watchScroll = function(){
  
  
  var h1 = $('.site-header').outerHeight();
  var h2 = $('.nav-bar').height();

  $(window).scroll(
    function(){
      
      
      
      if($(window).width() > 768){ // desktop
        
        var st = $(window).scrollTop();
        
        if(st >= h1){
           $('.nav-bar').addClass('sticky-5');
          $('#PageContainer').css('marginTop', h2);
        }else{
          $('.nav-bar').removeClass('sticky-5');
          $('#PageContainer').css('marginTop', 0);
        }
          
      }
      
    }
  );

}



timber.stickyFilters = function(){
  
  
  var h = $('.filters').offset().top;
  var i = $('.header-nav').outerHeight();
  var j = h-i;

  $(window).scroll(
    function(){
      
      
      
      if($(window).width() < 768 && false){ // mobile
        
        var st = $(window).scrollTop();
        var k = $('.filters').offset().top-$(window).scrollTop();
        var l = i-k;
        var m = k/i;
          

        
        console.log(k +'<'+ i);
        
        if(k < i){
          $('.header-nav').css('top', -l);
          $('.toggle-mobile-nav').css('opacity',0);
        }else{
          $('.header-nav').css('top', 0);
        	$('.toggle-mobile-nav').css('opacity',1);
        }
        
        if(st > h){
          $('.collection-sidebar .filters').addClass('fixed');
          $('.main-content').css('margin-top', $('.collection-sidebar .filters').outerHeight());
        }else{
          $('.collection-sidebar .filters').removeClass('fixed');
          $('.main-content').css('margin-top', 0);
        }
          
      }
      
    }
  );

}


function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie(cname) {
    var user = getCookie(cname);
    if (user != "") {
        return true;
    } else {
       return false;
    }
}




function colorSwatchesList(){
  
      $("label.color").on('click',function(){
        
        var parent = $(this).parent();
        
        if($(this).hasClass('number-6 hidden')){ // "+" clicked, reveal all colors
          parent.find(".color.hidden").each(function(){
            	$(this).hide().removeClass("hidden").fadeIn();
	        });

          return false;
        }

            
        	parent.find(".color").each(function(){
            	$(this).removeClass("selected");
	        });
        
        $(this).addClass("selected");

          var src = $(this).find(".imageSrc").first().val();
          var imageContainer = $(this).closest('.grid__item.product');
          var image = imageContainer.find(".grid__image img");
          var color = $(this).find('input[name="Color"]').val();
          var color_h = color.replace("'", "").replace(/\W+/g, "-").toLowerCase();
        
       	  var $a = $(this).parents('.product').find('a.link');
          var product_link = $a.attr('href');
        	var product_link_arr = product_link.split('#');
        	var hash = product_link_arr[1];
        if(hash){
          var hash_items = hash.split('/');
        	
        hash_items[1] = color_h;
        hash = hash_items.join('/');
        
        product_link_arr[1] = hash;
        
        var product_link2 = product_link_arr.join('#');
        $a.attr('href', product_link2);
          
        }
        

        var loader = imageContainer.find(".loader").first();
            loader.addClass("active");
          image.off("load");
          image.on("load",function(){
            loader.removeClass("active");
          });

          image.attr("src",src);
      });
  
  
  }
  


function fetchByAJAX(u){
  
//   	console.log('fetching...'+u);
  
  	var is_mobile =  $(window).width()<768;
    
    var $container = $('.collection-products .grid-uniform');
    $container.addClass('loading');
  
  	if(is_mobile){
        $('body').animate({'scrollTop': 0});
      	$('.header-nav').css('top',0);
      }
    
    $.get(u, function(r){
      
      window.history.pushState({"html":r, "ajax":true},"xxxx", u);
      
		$('.mobile-current-tags').html($(r).find('.mobile-current-tags').html());
      
      
          var $data = $(r).find('.collection-products');
      
          var $container = $('.collection-products .grid-uniform');
	      $container.removeClass('loading');
          
      
          $container.html('');
      
//           $('.collection-products').removeClass('loading');

          $('.loader').hide();
          
          var collection_title = $(r).find('.collection-description h1').html();
          var collection_description = $(r).find('.collection-description .rte').html();
          
          $('.collection-description h1').html(collection_title);
          $('.collection-description .rte').html(collection_description);
        
      
      var gridItems=$data.find('.grid__item');
      
      if(gridItems.length<9){
        	//collection.search.liquid
        	hasMore=false;
      }
      
      $.each(gridItems,
        function(i,o){
         $container.append($(o)); 
        }
      );
      
      
      // Refresh count      
      var n=$(gridItems).size();
      $('.collection-count').text('('+n+' Item'+(n>1?'s':'')+')');
      
      
      // Apply color swatches events
      colorSwatchesList();
      
      
      // re-call Lazyload
      refreshLazy();
          
      
      if(!is_mobile){
        $('body').animate({'scrollTop': 0});
      }
      
      $('.collection-products  .grid-uniform').fadeIn();
      
      
    }).fail(
          function(){
          	
            $('.loader').hide();
            $('.collection-products .grid-uniform').html('<span class="no-results">Collection not found.</span>').fadeIn();
          
          }
    );
       	
  
  }



function checkOtherFilters(){
  
 $('li.other-genders').each(
	function(i,o){

				var $a = $(o).find('a');
				var h = $a.attr('href');
              	var gender = $(o).attr('data-gender');
              
              	if($(o).hasClass('gender')) return;
              
              	checkByAJAX(h, $(o), gender);


	}
);
  
}

function checkByAJAX(u, $li, gender){
  
//   	console.log('fetching...'+u);
  

  
  	$.get(u, function(r){
      
      
	var n = $(r).find('.collection-products').find('.grid__item').length;
      
      if(n>0){
        $('li.gender.other-genders-title.'+gender).show();
		$li.show();
      }else{
        $li.remove();
      }
      
      
      
      
    }).fail(
          function(){
          	
// 			callback(0);
          }
    );
       	
  
  }


 function fetchNextPageByAJAX(u){
  
    retrieving=true;
//   	console.log('fetching... >> '+u);
  
  	var is_mobile =  $(window).width()<768;
    
    var $container = $('.collection-products .grid-uniform');
    $container.addClass('loading');
    
    var html="<div id='loadingMore'>Loading more ...</div>";
    $container.append(html);
    $("#loadingMore").animate({height:50,opacity: "1"},dt);
  
    
    $.get(u, function(r){
      
//     	window.history.pushState({"html":r, "ajax":true},"xxxx", u);
      
        var $data = $(r).find('.collection-products');
      
        var $container = $('.collection-products .grid-uniform');
        $container.removeClass('loading');
      
        //$container.html('');
      //$('.collection-products').removeClass('loading');

        $('.loader').hide();

        var collection_title = $(r).find('.collection-description h1').html();
        var collection_description = $(r).find('.collection-description .rte').html();

        $('.collection-description h1').html(collection_title);
        $('.collection-description .rte').html(collection_description);
          
        var gridItems=$data.find('.grid__item');
//         console.log("LENGTH: "+gridItems.length);
      
        if(gridItems.length<9)
          hasMore=false;

        $.each(gridItems,
               function(i,o){
                  $container.append($(o)); 
                }
              );
        
      	// Apply color swatches events
      	colorSwatchesList();
      
      
      // re-call Lazyload
		refreshLazy();
      
      	$('.collection-products  .grid-uniform').fadeIn();
      	$("#loadingMore").remove();
      	retrieving=false;
      
    }).fail(
          function(){
            $('.loader').hide();
            $('.collection-products .grid-uniform').html('<span class="no-results">Collection not found.</span>').fadeIn();
            
            $("#loadingMore").remove();
            
            retrieving=false;
          }
    );
  
  }
  


function filterClick($a){
  
  	
  
  	if(jQuery(window).width() < 768) closeMobileFilters();
  
  	//collection.search.liquid
   	hasMore=true;
  	var filter = $a.closest('ul').attr('data-filter');
  	var tag = $a.attr('data-tag-handle');
  	var u = $a.attr('href');
  	var filter_has_other_tags = (location.href.indexOf('+')>-1);
	var mobile = $(window).width()<768;
    

  if(timber.collection_filters){

    
  	var base_url = location.href.split('/');
	base_url.splice(-1,1); // remove current tags
  	base_url = base_url.join('/')+'/';
  
  	
  	}else{
      timber.collection_filters=[];
      var base_url = location.href;
      if(base_url.charAt(base_url.length-1)!='/') base_url+='/'; // Add a "/" at the end if not there
  	}
  
  	var $h4 = $a.closest('ul').prev('h4.filter-name-mobile');
  	var t = $a.text();
	var filter_name = $h4.find('a').attr('data-filter');
  

  
	if(filter_name) filter_name = filter_name.charAt(0).toUpperCase() + filter_name.slice(1); 

  	// Check if clicked filter is already on (except when "style" filter)
    if(filter!='style' && $a.closest('li').hasClass('on')){
      	$a.closest('li').removeClass('on');
      
      	// Reset filter
  		delete timber.collection_filters[filter]; 
      
      	// Update text of clicked filter in filter type name
		$h4.find('a span').text('');
      
    }else{
      
      if(filter=='style'){
        $('.filters ul.style').find('li.on').removeClass('on');
        $('.style-filters .filter-name-mobile span').text('');
        
      }else{
        $a.closest('ul').find('li.on').removeClass('on');
      }
      
      	
	    $a.closest('li').addClass('on');
      
        // Replace filters based on clicked one
  		timber.collection_filters[filter]=tag;
      
      
		// Update text of clicked filter in filter type name
		$h4.find('a span').text(t);
      
    }
  	


    
  
   // Reset mobile current tas
  
  $('.mobile-current-tags li.tag-'+filter).find('.filtered-items-icon-x').text('');
  
	
  
  
  
  	// Generate final URL + tags
  	var v = base_url;
  
  	for(var i in timber.collection_filters){
      v+=timber.collection_filters[i]+'+';
  	}
    
  	

    fetchByAJAX(v);
  
    if(mobile){
      $('h4.filter-name-mobile a.toggle').removeClass('on');

      $('ul.filter').slideUp(
        function(){
          $('h4.filter-name-mobile > span.icon').removeClass('icon-minus').addClass('icon-plus')
        }
      );
    }

}


function filterToggleClick($a){
  
  var filter = $a.attr('data-filter');

  var $ul = $('ul.'+filter);
  var $span = $a.parent().find('span.icon');
  
  console.log($ul);
  

  if($a.hasClass('on')){
    $span.removeClass('icon-minus').addClass('icon-plus');
    $a.removeClass('on');
    $ul.slideUp();

  }else{
    
    console.log('....');
    console.log($span);
    $span.removeClass('icon-plus').addClass('icon-minus');
    $a.addClass('on');
    $ul.slideDown();
  }
  
  
}



function styleFilterGenderFolders(){
  
//   var mobile = $(window).width()<768;

  $('.filter.style li[data-gender="kids"]').first().before($('<li>').text('KIDS').addClass('gender on'));
  $('.filter.style li[data-gender="men"]').first().before($('<li>').text('MEN').addClass('gender on'));
  $('.filter.style li[data-gender="women"]').first().before($('<li>').text('WOMEN').addClass('gender on'));
  
  $('.filter.style li.gender').click(
    function(){
      
      if(mobile) return false;
      
      var g = $(this).text().toLowerCase().replace(/\W+/g, "-");
    	
      if($(this).hasClass('on')){
        $(this).removeClass('on');
        $('.filter.style li[data-gender="'+g+'"]').slideUp();
      }else{
        $(this).addClass('on');
        $('.filter.style li[data-gender="'+g+'"]').slideDown();
      }
    
    }
  );
  
  
  
  
  $('___.filter.other-genders li.gender').click(
    function(){
      
      if(mobile) return false;
      
      var g = $(this).text().replace("'", "").replace(/\W+/g, "-").toLowerCase();
    	
      if($(this).hasClass('on')){
        $(this).removeClass('on');
        $('.filter.other-genders li[data-gender="'+g+'"]').slideUp();
      }else{
        $(this).addClass('on');
        $('.filter.other-genders li[data-gender="'+g+'"]').slideDown();
      }
    
    }
  );
  
}





function memberCheckout(id){
  
  if(parseInt(id)>0 || $('#CartDrawer').hasClass('customer')){
    window.location.replace("/checkout");
  }else{
    window.location.replace("/account/login?red=checkout");
  }
  
}





function presetLazyload(){
  
	$('.lazyload').each(
      function(i,o){
        
        var $img = $(o);
        var $container = $img.parent();
        
        var w = $container.width();
        
//         $img.css('height', w);
//         $img.css('width', '100%');
//         $img.css('background-image', 'url(https://cdn.dribbble.com/users/37649/screenshots/361958/preload.gif)');
        
        
//         $img.fadeOut();
        
      }
    );

    refreshLazy();
	
}


function fadeInJS(el,src){
  
//   el.style.opacity = 0;


  var x=true
  var n=0.05;
  
  var tick = function() {
    el.style.opacity = +el.style.opacity - n;


    if (+el.style.opacity > 0) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 500)
    }else{
    	
    }
  };

  tick();
}




function refreshLazy(){
  $('.lazy').Lazy({
    effect: "fadeIn",
          effectTime: 500,
          threshold: 0
                  });
}


var restoreNav_counter=0;

function resizeNav(w){
  


  var x=0;
  
  
  var a = $('#top-search').outerWidth(true)+10;
  var b = $('.header-desktop .site-header__logo').outerWidth(true);
  var c = $('.header-desktop .site-header__cart-toggle').outerWidth(true);
  
//   console.log(a);
//   console.log(b);
//   console.log(c);


  var nw = $(window).width();

  var __total_w = nw - (a+b+c+20);
  var max = 500;
  
  
  $('.site-nav').width(__total_w);

}



function cropNav2(at){
  
  var $lis = $('.site-nav li:visible');
  var $site_nav = $('.site-nav');
  var __inner_w=0;

  var a = $('#top-search').outerWidth(true);
  var b = $('.header-desktop .site-header__logo').outerWidth(true);
  var c = $('.header-desktop .site-header__cart-toggle').outerWidth(true);

  var max_items = 8;
  var p=0;
  var nw = $(window).width();

  var __total_w = nw - (a+b+c+10);
  
  
  $lis.each(
    function(i,o){
      p++;
      var w = $(o).outerWidth(true);
      __inner_w+=w;
      
    }
  );
  

  
  
//   console.log('TW: '+__total_w);
//   console.log('IW: '+__inner_w);
//   console.log('=======');
  
  
  
   
  var threshold =__total_w * .1;
    
  
  
  if(__inner_w+threshold > __total_w || p>max_items){ // Need to crop
    
    $('.site-nav li.more').show();
    
    var $site_nav_ul = $('.site-nav li.more > ul');
    
    if($site_nav_ul.size()==0){
      $('.site-nav li.more').append('<ul class="second-level-menu b">');
      $site_nav_ul = $('.site-nav li.more > ul');
    }else{
      $site_nav_ul.show();
    }
    
    
    var $last_visible_element = $('.site-nav > li:visible:not(.more):last');
    
    $last_visible_element.addClass('hidden');
    
    var t = $last_visible_element.find('a').first().text();
    var h = $last_visible_element.find('a').first().attr('href');
    
    var $li = $('<li>').append($('<a>').text(t).attr('href',h));
    
    if($('.site-nav li.more > ul').find('li:contains('+t+')').size()<1){
      $site_nav_ul.prepend($li);
    }else{
      $('.site-nav li.more > ul').find('li:contains('+t+')').show();
    }
    
    
    cropNav2();
  
  }
  
  
  var z = ($('.site-nav li.more > ul li').size());
    
  if(z == 0){
    $('.site-nav li.more > ul').remove();
    $('.site-nav li.more').hide();
  }
  
  
  return;
  
  
  
  
}



function restoreNav2(at){
  
  
  var $lis = $('.site-nav li:visible');
  var $site_nav = $('.site-nav');
  var __inner_w=0;
  
  var max_items = 8;
  var p=0;

  var a = $('#top-search').outerWidth(true);
  var b = $('.header-desktop .site-header__logo').outerWidth(true);
  var c = $('.header-desktop .site-header__cart-toggle').outerWidth(true);
  
  var $first_hidden_element = $('.site-nav > li.hidden:first');
  var d = $first_hidden_element.outerWidth();

  var nw = $(window).width();

  var __total_w = nw - (a+b+c+10);
  
  
  var threshold =__total_w * .1;
  
  
  
  
  $lis.each(
    function(i,o){
      
      var w = $(o).outerWidth();
      __inner_w+=w;
      p++;
      
    }
  );
  
    

  
  
  if(__inner_w+threshold+d <= __total_w && p<max_items){
    
    
    var t = $first_hidden_element.find('a').first().text();
    $('.site-nav li.more > ul').find('li:contains('+t+')').remove();
    $first_hidden_element.removeClass('hidden');
    
    var z = ($('.site-nav li.more > ul li').size());
    
    if(z == 0){
      $('.site-nav li.more > ul').remove();
      $('.site-nav li.more').hide();
    }
  
  }
  
  

  
  
}



function showMobileFilters(){
  	
    $('.filters').show().animate({right: 0});
    $('body').addClass('noscroll');
    
  }
  
  function closeMobileFilters(){
  	
    $('.filters').show().animate({right: '-100%'});
    $('body').removeClass('noscroll');
    
  }